/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import moment from 'moment';

export default class CommentsRoute extends Route {
  queryParams = {
    status: {
      // Not strictly necessary, but helps us show up-to-date data.
      refreshModel: true,
    },
  };

  // Services
  @service
  dates;

  @service
  permissions;

  @service
  session;

  @service
  store;

  model(params) {
    let postParams = {
      include: 'comments',
      startTime: (moment(this.dates.rolloverDate).isValid()
        ? moment(this.dates.rolloverDate)
        : moment()
      ).unix(),
      moderationStatus: JSON.stringify([params.status]),
      metaOnly: true,
    };
    if (!this.permissions.meet(Scopes.TENANT_ADMIN)) {
      postParams.authorId = this.session.personId;
    }

    return this.store
      .query('posts/communitynotice', postParams)
      .then((posts) => {
        let postIds = posts.map((post) => post.id);
        return this.store.peekAll('posts/comment').filter((comment) => {
          return postIds.includes(comment.get('post.id'));
        });
      });
  }
}
